"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveUsersJSONModel = void 0;
const lodash_1 = __importDefault(require("lodash"));
const PeriodDaysJSONModel_1 = require("src/hello_assets/src/components/model/common/periodDays/PeriodDaysJSONModel");
const AutoSequenceJSONModel_1 = require("src/hello_assets/src/components/model/common/AutoSequenceJSONModel");
const AggregationJSONModel_1 = require("src/hello_assets/src/components/model/common/AggregationJSONModel");
const ActiveUsersChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/activeUsers/model/ActiveUsersChartSettingsJSONModel");
class ActiveUsersJSONModel {
    constructor(serializedState) {
        this.sequenceJSONModel = new AutoSequenceJSONModel_1.AutoSequenceJSONModel();
        this.periodDaysJSONModel = new PeriodDaysJSONModel_1.PeriodDaysJSONModel();
        this.aggregationJSONModel = new AggregationJSONModel_1.AggregationJSONModel();
        this.chartSettingsJSONModel = new ActiveUsersChartSettingsJSONModel_1.ActiveUsersChartSettingsJSONModel();
        this.reset = () => {
            this.sequenceJSONModel.reset();
            this.periodDaysJSONModel.reset();
            this.aggregationJSONModel.reset();
            this.chartSettingsJSONModel.reset();
        };
        this.overwriteFromSerializedStateString = (serializedState) => {
            let parsed = undefined;
            try {
                if (lodash_1.default.isString(serializedState)) {
                    parsed = JSON.parse(serializedState);
                }
            }
            catch (e) {
            }
            return this.overwriteFromSerializedState(parsed);
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                this.sequenceJSONModel.overwriteFromSerializedState(serializedState.sequence);
                this.periodDaysJSONModel.overwriteFromSerializedState(serializedState.period);
                this.aggregationJSONModel.overwriteFromSerializedState(serializedState.aggregation);
                this.chartSettingsJSONModel.overwriteFromSerializedState(serializedState.chart);
            }
        };
        this.serialize = () => {
            return {
                sequence: this.sequenceJSONModel.serialize(),
                period: this.periodDaysJSONModel.serialize(),
                aggregation: this.aggregationJSONModel.serialize(),
                chart: this.chartSettingsJSONModel.serialize(),
            };
        };
        this.getSequenceJSONModel = () => this.sequenceJSONModel;
        this.getPeriodDaysJSONModel = () => this.periodDaysJSONModel;
        this.getAggregationJSONModel = () => this.aggregationJSONModel;
        this.getChartSettingsJSONModel = () => this.chartSettingsJSONModel;
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.ActiveUsersJSONModel = ActiveUsersJSONModel;
////////////////////////////////////////////////
// URL state validator
////////////////////////////////////////////////
ActiveUsersJSONModel.isModelEmpty = (serializedState) => {
    return true;
};
ActiveUsersJSONModel.makeModelStateClean = (serializedState) => {
    return serializedState;
};
